import { render } from "./vestingTab.vue?vue&type=template&id=77fecefc"
import script from "./vestingTab.vue?vue&type=script&lang=ts"
export * from "./vestingTab.vue?vue&type=script&lang=ts"

import "./vestingTab.vue?vue&type=style&index=0&id=77fecefc&lang=scss"
script.render = render

export default script